





















import { Component, Vue } from "vue-property-decorator";
import StaffList from "@/components/sale/list/StaffList.vue";

@Component({
  components: { StaffList },
})
export default class extends Vue {
  public partner_id = 0;

  public created() {
    this.partner_id = Number(this.$route.params.partner_id);
  }
}
